export default __webpack_public_path__ + "static/media/profono.6fdb728f.png";